import axios from 'axios';
import Base  from "../Base";

const url = {
  index: "/api/quiz/lead",
};

class Quiz extends Base {

  static getComponents() {
    return {
      "quiz": require("./Parts/Quiz"),
    };
  }

  static sendLead = async (data)=>
    (await axios.post(url.index, data)).data;

}

export default Quiz;
